import Tabs from '@components/V4/Tabs/Tabs';
import { Enrollment } from '@shared/common';
import EnrollmentChangeLogSection from '../EnrollmentChangeLogSection/EnrollmentChangeLogSection';
import EnrollmentMentorHistorySection from '../EnrollmentMentorHistorySection/EnrollmentMentorHistorySection';
import EnrollmentStatusHistorySection from '../EnrollmentStatusHistorySection/EnrollmentStatusHistorySection';
import SessionsListSection from '../SessionsListSection/SessionsListSection';

export type EnrollmentTab = 'sessions-list' | 'status-history' | 'mentor-history' | 'change-log';

interface EnrollmentTabsSectionProps {
  tab?: EnrollmentTab;
  onSessionModalOpen: (session: any) => void;
  enrollment: Enrollment;
}

const EnrollmentTabsSection = (props: EnrollmentTabsSectionProps) => {
  const { tab = 'sessions-list', onSessionModalOpen, enrollment } = props;

  const tabs: { label: string; value: EnrollmentTab }[] = [
    { label: 'Sessions List', value: 'sessions-list' },
    { label: 'Status History', value: 'status-history' },
    { label: 'Mentor History', value: 'mentor-history' },
    { label: 'Admin Change Log', value: 'change-log' },
  ];

  const renderContent = (currentTab: EnrollmentTab) => {
    switch (currentTab) {
      case 'sessions-list':
        return (
          <SessionsListSection onSessionModalOpen={onSessionModalOpen} enrollment={enrollment} />
        );
      case 'status-history':
        return <EnrollmentStatusHistorySection enrollmentId={enrollment._id} />;

      case 'mentor-history':
        return <EnrollmentMentorHistorySection enrollment={enrollment} />;

      case 'change-log':
        return <EnrollmentChangeLogSection enrollmentId={enrollment._id} />;
      default:
        return null;
    }
  };

  return (
    <div>
      <Tabs tabs={tabs} initialTab={tab} renderContent={renderContent} />
    </div>
  );
};

export default EnrollmentTabsSection;
